import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { isArray } from 'Utils/isArray';
import { isObject } from 'Utils/isObject';
import { MenuItemRender } from './MenuItemRender';
import { convertItemsMenu } from 'Utils/convertItemsMenu';
import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';
import ynToBool from 'Utils/ynToBool';
import generateUUID from 'Utils/generateUUID';
import { ShowcaseMenu } from 'redux/Reducers/Showcases/ShowcaseMenuReducer';
import useActiveCampaign from 'Hooks/useVertemGift';
import { getParticipantGroupThunk } from 'redux/Reducers/ParticipantGroup/getParticipantGroupSlice';
import { notification } from '@vertem-core/vertice-ds';
import { HasConciergeService } from 'Constants/Concierge';
import useGiftPermissions from 'Hooks/useGiftPermissions';
import { getCategoriesChips } from 'redux/Reducers/CategoriesChips/CategoriesChipsReducer';
import { getParticipantIsFocalPointThunk } from 'redux/Reducers/FocalPoint/getParticipantIsFocalPointSlicer';


const defaultProps = {
  label: PropTypes.string.isRequired,
  path: PropTypes.string,
  type: PropTypes.string,
  dynamicAction: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      title: PropTypes.string,
      icon: PropTypes.string,
      type: PropTypes.string,
      path: PropTypes.string,
    })
  ),
};

export const MenuItems = ({ type='services', ...props }) => {
  const { items, label, dynamicAction, path } = props;
  const menuItems = convertItemsMenu(items, true, type, dynamicAction);
  if (menuItems.length > 0) {
    return <MenuItemRender label={label} items={menuItems} />;
  } else if (path) {
    return <MenuItemRender label={label} path={path} />;
  }
};

MenuItems.propTypes = {
  ...defaultProps,
};

const MenuItemsMobile = ({ label, menuType }) => {
  const CmsStatic = useSelector(({ CmsStatic: data }) => data);
  const { categoryMenu } = CmsStatic?.cms;
  const SpotGroups = useSelector(({ SpotGroups: data }) => data);
  const [cms, setCms] = useState({});
  const { cms: cmsData } = CmsStatic;
  const [accessRelatory, setAccessRelatory] = useState(null);
  const [customSubMenu, setCustomSubMenu] = useState([]);
  const [customSolicitation, setCustomSolicitation] = useState([]);
  const [validateSolicitation, setValidateSolicitation] = useState(null);
  const [hasAccessToPix, setHasAccessToPix] = useState(false);
  const { giftInfo: giftsActiveOnCampaign } = useSelector(
    (state) => state.Gift
  );
  const { isCallingActiveVertemGift, isCampaignActive } = useActiveCampaign();
  const isAccessGift = useGiftPermissions();

  const { user } = useSelector((state) => state.oidc);




  const { successShowcaseMenu, dataShowcaseMenu } = useSelector(
    (state) => state.ShowcaseMenu
  );
  const Participants = useSelector(({ Participants: data }) => data);

  const dispatch = useDispatch();


  useEffect(() => {
    const isDynamicAction = categoryMenu?.some(
      ({ dynamicAction }) => dynamicAction === 'loadCategories'
    );
    if (isDynamicAction) {
      dispatch(getCategoriesChips());
    }
  }, [categoryMenu]);


  const {
    isFocalizationAnalyst,
    isLead: isLeader,
    isManager,
    isPMO,
    getRedemptionSpotGroups,
  } = useParticipantSubSegment();
  const { dataGetParticipantIsFocalPoint } = useSelector( (state) => state.GetParticipantIsFocalPoint);
  const { participantGroups: participantGroupData } = useSelector(


    (state) => state.ParticipantGroups
  );

  const handleValidateSolicitation = useCallback(() => {
    setValidateSolicitation(
      isPMO ||
        isLeader ||
        isManager ||
        isFocalizationAnalyst ||
        getRedemptionSpotGroups()
    );
  }, [
    isPMO,
    isLeader,
    isManager,
    isFocalizationAnalyst,
    getRedemptionSpotGroups,
  ]);

  const loadShowCase = useCallback(() => {
    dispatch(ShowcaseMenu());
  }, [dispatch]);

  const handleAddShowcaseMenu = () => {
    if (dataShowcaseMenu?.length > 0) {
      const list = dataShowcaseMenu.map(item => (
        {
          context: [],
          items: [],
          path: `/showcase/${item.identifier}`,
          label: item.title,
          enabled: true,
          type: 'services',
        }


      ));

      const listFilter = list.filter(({ path, label, type }) =>
        !customSubMenu.some(({ path: p, label: l, type: t }) =>
          path === p && label === l && type === t
        )
      );

      if (setCustomSubMenu && listFilter.length) {
        setCustomSubMenu([...customSubMenu, ...listFilter]);
      }
    }
  };

  useEffect(() => {
    loadShowCase();
    loadParticipantIsFocalPointThunk();
  }, []);

  useEffect(() => {
    if (successShowcaseMenu) {
      handleAddShowcaseMenu();
    }
  }, [successShowcaseMenu, handleAddShowcaseMenu]);

  const validateGiftsMenu = useCallback(() => {
    if (
      participantGroupData &&
      Array.isArray(participantGroupData) &&
      participantGroupData.length > 0 &&
      giftsActiveOnCampaign &&
      Array.isArray(giftsActiveOnCampaign.groups) &&
      giftsActiveOnCampaign.groups.length > 0
    ) {
      return (
        participantGroupData.some((item) =>
          giftsActiveOnCampaign.groups.includes(item.name)
        ) ||
        giftsActiveOnCampaign.products.some(
          (product) => product.groups && product.groups.length > 0
        )
      );
    }

    if (
      Array.isArray(giftsActiveOnCampaign?.products) &&
      giftsActiveOnCampaign?.products.length > 0
    ) {
      return giftsActiveOnCampaign?.products.some(
        (product) => product.groups && product.groups.length > 0
      );
    }

    return false;
  }, [
    participantGroupData,
    giftsActiveOnCampaign,
    giftsActiveOnCampaign?.products,
  ]);

  const processEnvValue = ynToBool(process.env.REACT_APP_SPOT_REDEMPTION);

  useEffect(() => {
    const hasPixEnv = ynToBool(process.env.REACT_APP_HAS_PIX);
    const allowedPixUsersEnv = process.env.REACT_APP_ALLOWED_PIX_USERS;
    const enabledCatalogs = process.env.REACT_APP_ALLOWED_PIX_CATALOG


    const participantCpfCnpj = Participants?.cpfCnpj?.value.trim();

    let hasAccesPix = false;

    const allowedPixCatalog = () => {
      if (enabledCatalogs) {
        const enabledCatalogsArray = enabledCatalogs
          .split(',')
          .map((catalog) => catalog.trim());
        return enabledCatalogsArray.includes(user?.profile['custom:catalog_id'])
      }
      return false;
    }

    if (hasPixEnv && allowedPixCatalog()) {
      if (allowedPixUsersEnv) {
        const allowedUsersArray = allowedPixUsersEnv
          .split(',')
          .map((user) => user.trim());
        hasAccesPix = allowedUsersArray.includes(participantCpfCnpj);

        setHasAccessToPix(hasAccesPix);
        return;
      }
      hasAccesPix = true;
      setHasAccessToPix(hasAccesPix);
      return;
    }
    setHasAccessToPix(hasAccesPix);
  }, [Participants?.cpfCnpj?.value]);

  useEffect(() => {
    if (
      ynToBool(process.env.REACT_APP_SHOW_CAMPAIGN_MIGRATION_MENU) &&
      cms?.categoryMenu &&
      !cms?.categoryMenu.filter(({ path }) => path === '/solicitation')
        .length &&
      SpotGroups &&
      SpotGroups.hasSyngentaHierarchy
    ) {
      setCustomSolicitation([
        {
          context: ['points', 'cash'],
          enabled: true,
          items: [],
          label: 'Solicitação',
          path: '/solicitation',
          type: 'internal-link',
        },
      ]);
    }
  }, [SpotGroups, cms]);

  useEffect(() => {
    if (cmsData) {
      setCms({ ...cmsData });
    }
  }, [cmsData]);

  const loadParticipantIsFocalPointThunk = () => {
    dispatch(getParticipantIsFocalPointThunk());
  }

  const customSubMenuContainsFocalPoint = () => {
    return customSubMenu.some(custom => custom.label === "Focal Point");
  }



  const handleAddFocalPointMenu = () => {
    if (ynToBool(process.env.REACT_APP_FOCALPOINT_CAMPAIGN_HAS_FOCAL_POINT) && dataGetParticipantIsFocalPoint && !customSubMenuContainsFocalPoint()) {
      var focalPointMenu = {
        items: [
          {
            items: [],
            path: '/list-manage-points',
            label: 'Gerenciar distribuição de pontos'
          },
          {
            items: [],
            path: '/list-history-distribution-points',
            label: 'Histórico de distribuição de pontos'
          },
        ],
        label: 'Focal Point',
        enabled: true,
        type: 'services',
      }
      setCustomSubMenu([...customSubMenu, focalPointMenu]);
    }
  }


  useEffect(() => {
    if (dataGetParticipantIsFocalPoint) {
      handleAddFocalPointMenu();
    }
  }, [dataGetParticipantIsFocalPoint]);

  useEffect(() => {
    handleAddFocalPointMenu();
  }, [customSubMenu]);


  React.useLayoutEffect(() => {
    const customSubMenuFilter = [
      processEnvValue && {
        context: ['points'],
        items: [
          {
            items: [],
            path: '/list-redemptions',
            label: 'Ver Solicitações',
            subCategoryId: 0,
            enabled: true,
          },
          validateSolicitation && {
            items: [],
            path: '/spot-redemption',
            label: 'Nova Solicitação',
            subCategoryId: 0,
            enabled: validateSolicitation,
          },
        ].filter(Boolean),
        label: 'Solicitações',
        enabled: true,
        type: 'services',
      },
  
      processEnvValue &&
        accessRelatory && {
          items: [
            {
              items: [],
              path: '/redemptions-report',
              label: 'Solicitações e Resgates de Clientes',
              subCategoryId: 0,
              enabled: validateSolicitation,
            },
          ],
          label: 'Relatórios',
          enabled: true,
          type: 'services',
        },
  
      ynToBool(process.env.REACT_APP_VALIDATE_ACCESS_GIFT_MENU) &&
        validateGiftsMenu() &&
        isAccessGift && {
          context: [],
          items: [],
          path: '/gift',
          label: process.env.REACT_APP_GIFT_MENU_LABEL_CUSTOM || 'Brindes',
          enabled: true,
          type: 'services',
        },
  
      ynToBool(process.env.REACT_APP_HAS_VERTEM_GIFT) &&
        ynToBool(isCampaignActive) && {
          context: [],
          items: [],
          path: '/campanhas',
          label: 'Campanhas',
          enabled: true,
          type: 'services',
        },
  
      hasAccessToPix &&
        {
          context: [],
          items: [],
          path: '/transferencia-bancaria',
          label: 'Transferência Bancária',
          enabled: true,
          type: 'services',
        },


        (ynToBool(process.env.REACT_APP_FOCALPOINT_CAMPAIGN_HAS_FOCAL_POINT) && dataGetParticipantIsFocalPoint && !customSubMenuContainsFocalPoint()) &&
        {
          items: [
            {
              items: [],
              path: '/list-manage-points',
              label: 'Gerenciar distribuição de pontos'
            },
            {
              items: [],
              path: '/list-history-distribution-points',
              label: 'Histórico de distribuição de pontos'
            },
          ],
          label: 'Focal Point',
          enabled: true,
          type: 'services',
        },



    ].filter(Boolean);

  
    setCustomSubMenu(customSubMenuFilter);
  }, [
    accessRelatory,
    validateSolicitation,
    validateGiftsMenu,
    isAccessGift,
    isCampaignActive,
    Participants?.cpfCnpj?.value,
    processEnvValue,
    hasAccessToPix
  ]);

  useEffect(() => {
    setAccessRelatory(isPMO || isLeader || isManager || isFocalizationAnalyst);
    handleValidateSolicitation();
  }, [
    isPMO,
    isLeader,
    isManager,
    isFocalizationAnalyst,
    handleValidateSolicitation,
  ]);

  const [menu, setMenu] = useState([]);

  const {
    participantGroups,
    participantGroupHasError,
  } = useSelector(state => (
    state.GetParticipantGroup
  ));

  const getMenuItemGroups = (menuItem) => {
    return menuItem.context.find(context => context?.groups)?.groups ?? [];
  }

  const isMenuVisibleForUserGroup = (menuItem) => {
    const menuItemGroups = getMenuItemGroups(menuItem);

    if (menuItemGroups.length == 0) return true;
    if (participantGroups.groups.length == 0) return false;

    return participantGroups.groups.some(userGroup => menuItemGroups.includes(userGroup));
  }

  const disableUserGroupMenu = () => {
    if (!Array.isArray(cms[menuType])) return;

    const updatedMenu = [...cms[menuType]];

    updatedMenu.forEach(menuItem => {
      if (menuItem.enabled == false) return;

      menuItem.enabled = isMenuVisibleForUserGroup(menuItem);
    });

    setMenu(updatedMenu);
  }

  useEffect(() => {
    if (cms) setMenu(cms[menuType]);
  }, [cms]);

  useEffect(() => {
    if (!ynToBool(HasConciergeService)) return;
    dispatch(getParticipantGroupThunk());
  }, []);

  useEffect(() => {
    if (!ynToBool(HasConciergeService)) return;
    if (!cms || !participantGroups) return;

    disableUserGroupMenu();
  }, [cms, participantGroups]);

  useEffect(() => {
    if (!participantGroupHasError) return;

    notification.error({
      message: "Houve um erro ao carregar os grupos do usuário, menus segmentados podem não funcionar corretamente.",
    });
  }, [participantGroupHasError]);

  return (
    <>
      {
        menu && menu.length > 0 &&
          menu.map(item => 
            item.enabled && (
              <MenuItems
                key={generateUUID()}
                path={item.path}
                label={item.label}
                type={item.type}
                dynamicAction={item.dynamicAction}
                items={item.items}
              />
            )
          )
      }

      {isObject(cms[menuType]) ? (
        <MenuItems
          label={label || cms[menuType].label}
          items={cms && cms[menuType] && cms[menuType].items}
        />
      ) : null}

      {customSolicitation?.map((item) => (
        <MenuItems
          key={generateUUID()}
          path={item?.path}
          label={item?.label}
          type={item?.type}
          dynamicAction={item?.dynamicAction}
          items={item?.items}
        />
      ))}

      {isArray(cms[menuType])
        ? customSubMenu.map((item) =>
            item.enabled ? (
              <MenuItems
                key={generateUUID()}
                path={item?.path}
                label={item?.label}
                type={item?.type}
                dynamicAction={item?.dynamicAction}
                items={item?.items}
              />
            ) : null
          )
        : ''}
    </>
  );
};

MenuItemsMobile.propTypes = {
  label: PropTypes.string.isRequired,
  menuType: PropTypes.oneOf([
    'categoryMenu',
    'tradeMenu',
    'headerMenu',
    'footerMenu',
  ]),
};

export default MenuItemsMobile;
